var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-widget-cell"},[(_vm.title.length > 0)?_c('div',{staticClass:"info-widget-cell__title"},[_vm._v(_vm._s(this.$t(_vm.title)))]):_vm._e(),_c('div',{ref:"data",staticClass:"info-widget-cell__data",class:{ 'info-widget-cell__data--fit': _vm.fitToWidth }},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }